<div class="display-flex">
  <div class="row width-100">
    <div class="col-lg-5 col-md-5 col-sm-5"
         [ngClass]="{'users-by-roles-property-invalid':notValid}" 
         >
      <gs-multiselect *ngIf="rolesProperty"
                      [item]="item"
                      [property]="rolesProperty"
                      [maxSelectedLabels]="1">
      </gs-multiselect>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6"
         [ngClass]="{'users-by-roles-property-invalid':notValid}" 
         >
      <gs-multiselect *ngIf="usersProperty"
                      [item]="item"
                      [property]="usersProperty"
                      [maxSelectedLabels]="0">
      </gs-multiselect>
    </div>
    <div *ngIf="notValid"
          class="form-error col-lg-1 col-md-1 col-sm-1"
          pTooltip="{{property.validationMessage}}"
          tooltipPosition="top"
          style="top:25px;">
      <i class="fas fa-info-circle fa-2x form-valid-icon with-icon error-color"></i>
    </div>    
  </div>
 
</div>
